/* eslint-disable max-len */

export default {
  // Global styles apply to _all_ inputs with matching section keys
  global: {
    fieldset: 'max-w-md border-none px-2 pb-1',
    help: 'font-main text-base text-old-balck-70',
    inner: 'formkit-disabled:bg-old-gray-200 formkit-disabled:cursor-not-allowed formkit-disabled:pointer-events-none',
    input: 'appearance-none focus:outline-none focus:ring-0 focus:shadow-none font-main',
    label: 'block mb-1 text-base text-old-n-black-100 font-normal font-main',
    legend: 'font-semibold text-lg',
    loaderIcon: 'inline-flex items-center w-4 text-old-gray-600 animate-spin',
    message: 'text-old-red-500 mb-1 text-base',
    messages: 'list-none p-0 mt-1 mb-0 absolute',
    outer: 'relative mb-4 font-main formkit-disabled:opacity-50 [&.absolute]:absolute [&.mb-0]:mb-0',
    prefixIcon:
      `w-10 flex self-stretch grow-0 shrink-0
      rounded-tl rounded-bl border-r border-old-gray-400 bg-old-white bg-gradient-to-b from-old-transparent to-old-gray-200
      [&>svg]:w-full [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto`,
    suffixIcon:
      `w-28 pr-3 p-3 flex self-stretch grow-0 shrink-0
      [&>svg]:w-full [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto`,
    textarea: 'font-main',
  },

  // Family styles apply to all inputs that share a common family
  'family:box': {
    decorator:
      `block relative h-20 w-20 mr-8 border-4
      bg-old-white bg-gradient-to-b from-old-transparent to-old-gray-200 ring-1 ring-old-gray-n-40 peer-checked:ring-old-blue-500 text-old-transparent peer-checked:text-old-blue-500`,
    decoratorIcon:
      'flex p-[3px] w-full h-full absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2',
    help: 'mb-2 mt-1.5',
    input:
      'absolute w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer',
    inner: '$remove:formkit-disabled:bg-old-gray-200',
    label: '$reset text-base text-old-n-black-100 font-normal mt-1 select-none',
    wrapper: 'flex items-center mb-1',
  },
  'family:button': {
    outer: '[&.mb-0]:mb-0',
    input:
      `$reset
      inline-flex justify-center w-full items-center h-48 py-12 px-16 bg-old-fill-accent-primary-default text-old-text-on-accent-primary text-lg font-medium rounded-lg box-border
      hover:bg-old-fill-accent-primary-hover active:bg-old-fill-accent-primary-selected
      focus-visible:outline-2 focus-visible:outline-old-blue-600 focus-visible:outline-offset-2
      formkit-disabled:text-old-text-neutral-disabled formkit-disabled:bg-old-n-gray-50

      [&.medium]:h-40 [&.medium]:text-base
      [&.small]:h-32 [&.small]:text-base

      [&.text]:h-20 [&.text]:py-0 [&.text]:text-lg [&.text]:font-medium [&.text]:text-old-n-blue-80 [&.text]:bg-old-transparent
      [&.text]:hover:text-old-n-blue-90
      formkit-disabled:[&.filled]:text-old-n-gray-80

      [&.text.small]:text-base
      [&.text.thin]:font-normal

      [&.text.black]:text-old-text-neutral-primary
      [&.text.black]:hover:text-old-n-blue-90

      [&.link]:h-20 [&.link]:text-base [&.link]:font-normal [&.link]:text-old-text-neutral-primary [&.link]:bg-old-transparent
      [&.link]:hover:text-old-n-blue-90
      formkit-disabled:[&.filled]:text-old-n-gray-80

      [&.filled]:bg-old-n-blue-20 [&.filled]:text-old-n-blue-80 [&.filled]:text-old-n-blue-80
      [&.filled]:hover:bg-old-n-blue-30 [&.filled]:active:bg-old-n-blue-40
      formkit-disabled:[&.filled]:bg-old-n-gray-20 formkit-disabled:[&.filled]:text-old-n-gray-90

      formkit-disabled:[&.danger]:text-old-n-gray-80

      [&.danger]:bg-old-fill-error-primary-default
      [&.danger]:hover:bg-old-fill-error-primary-hover [&.danger]:active:bg-old-fill-error-primary-selected
      formkit-disabled:[&.danger]:bg-old-fill-error-primary-disabled formkit-disabled:[&.danger]:text-old-text-neutral-disabled

      [&.danger.filled]:bg-old-red-10 [&.danger.filled]:text-old-n-red-80
      [&.danger.filled]:hover:bg-old-red-20 [&.danger.filled]:active:bg-old-red-20
      formkit-disabled:[&.danger.filled]:bg-old-n-gray-20 formkit-disabled:[&.danger.filled]:text-old-n-gray-90

      [&.icon]:h-32 [&.icon]:w-32 [&.icon]:p-8 [&.icon]:text-sm [&.icon.text]:text-sm

      [&.fit]:p-0 [&.fit]:w-fit

      [&.outline]:bg-old-transparent [&.outline]:text-old-n-blue-80 [&.outline]:border-2 [&.outline]:border-old-n-blue-80 [&.outline]:outline-none
      [&.outline]:hover:border-old-n-blue-90 [&.outline]:active:border-old-n-blue-100
      formkit-disabled:[&.outline]:bg-old-n-gray-20 formkit-disabled:[&.outline]:text-old-n-gray-90`,
    wrapper: 'mb-1',
    prefixIcon: '$reset flex w-16 mr-4 stretch',
    suffixIcon: '$reset flex w-16 ml-2 stretch',
  },
  'family:dropdown': {
    dropdownWrapper:
      'my-2 w-full shadow-lg rounded [&::-webkit-scrollbar]:hidden',
    emptyMessageInner:
      'flex items-center justify-center text-sm p-2 text-center w-full text-old-gray-500 [&>span]:mr-3 [&>span]:ml-0',
    inner:
      `max-w-md relative flex
      ring-1 ring-old-n-gray-40 ring-inset focus-within:ring-old-black focus-within:ring-2 rounded mb-2
      formkit-disabled:focus-within:ring-old-black formkit-disabled:focus-within:ring-1
      [&>span:first-child]:focus-within:text-old-blue-500`,
    input: 'w-full px-12 py-8',
    listbox: 'bg-old-white shadow-lg rounded overflow-hidden',
    listboxButton: 'flex w-12 self-stretch justify-center mx-auto',
    listitem:
      `pl-7 relative
      hover:bg-old-gray-300
      data-[is-active="true"]:bg-old-gray-300
      aria-selected:bg-old-blue-600 aria-selected:text-old-white data-[is-active="true"]:aria-selected:bg-old-blue-600 data-[is-active="true"]:aria-selected:bg-old-blue-700`,
    loaderIcon: 'ml-auto',
    loadMoreInner:
      `flex items-center justify-center w-full p-2
      text-sm text-center text-old-blue-500 cursor-pointer
      formkit-loading:text-old-gray-500
      [&>span]:mr-3 [&>span]:ml-0`,
    option: 'p-2.5',
    optionLoading: 'pl-2.5 text-old-gray-400',
    placeholder: 'p-2.5 text-old-gray-400',
    selector:
      'flex w-full justify-between items-center min-h-[2.625em] [&u] cursor-default',
    selection: 'flex w-full',
    selectedIcon: 'block absolute top-1/2 left-2 w-3 -translate-y-1/2',
    selectIcon:
      'flex box-content w-4 px-2 self-stretch grow-0 shrink-0 [&>svg]:w-[1em] cursor-pointer',
  },
  'family:text': {
    inner:
      `flex items-center max-w-md mb-1
      ring-1 ring-old-n-gray-40 ring-inset rounded
      focus-within:ring-old-black focus-within:ring-2 [&>label:first-child]:focus-within:text-old-blue-500`,
    input:
      `w-full h-48 px-16 py-8 border-none text-lg text-old-gray-700 placeholder-old-gray-400
      [&.small]:h-40 [&.small]:text-base`,
    textarea: 'formkit-input w-full h-135 px-16 py-8 border-none text-lg text-old-gray-700 placeholder-old-gray-400 resize-none',
    outer:
      `[&>*>.formkit-inner]:data-[invalid=true]:ring-old-n-red-100
      [&>*>.formkit-inner]:data-[errors=true]:ring-old-n-red-100`,
  },
  'family:date': {
    inner:
      `flex items-center max-w-md mb-1 ring-1 ring-old-n-gray-40 ring-inset rounded
      focus-within:ring-old-black focus-within:ring-2 [&>label:first-child]:focus-within:text-old-blue-500`,
    input: 'w-full px-12 py-12 border-none text-old-gray-700 placeholder-old-gray-400',
  },

  // Specific styleas apply only to a given input type
  color: {
    inner:
      'flex max-w-[5.5em] w-full formkit-prefix-icon:max-w-[7.5em] formkit-suffix-icon:formkit-prefix-icon:max-w-[10em]',
    input:
      '$reset appearance-none w-full cursor-pointer border-none rounded p-0 m-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:border-none',
    suffixIcon: 'min-w-[2.5em] pr-0 pl-0 m-auto',
  },
  file: {
    fileItem: 'flex items-center text-old-gray-800 mb-1 last:mb-0',
    fileItemIcon: 'w-4 mr-8 shrink-0',
    fileList:
      'shrink grow peer px-12 py-8 formkit-multiple:data-[has-multiple="true"]:mb-6',
    fileName: 'break-all grow text-ellipsis',
    fileRemove:
      'relative z-[2] ml-auto text-[0px] hover:text-old-red-500 pl-2 peer-data-[has-multiple=true]:text-sm peer-data-[has-multiple=true]:text-old-blue-500 peer-data-[has-multiple=true]:ml-3 peer-data-[has-multiple=true]:mb-2 formkit-multiple:bottom-[0.15em] formkit-multiple:pl-0 formkit-multiple:ml-0 formkit-multiple:left-[1em] formkit-multiple:formkit-prefix-icon:left-[3.75em]',
    fileRemoveIcon: 'block text-base w-3 relative z-[2]',
    inner:
      'relative max-w-md cursor-pointer formkit-multiple:[&>button]:absolute',
    input:
      'cursor-pointer text-old-transparent absolute top-0 right-0 left-0 bottom-0 opacity-0 z-[2]',
    noFiles: 'flex w-full items-center px-12 py-8 text-old-gray-400',
    noFilesIcon: 'w-4 mr-8',
  },
  radio: {
    decorator: 'rounded-full',
    decoratorIcon: 'w-5 p-[5px]',
  },
  range: {
    inner: '$reset flex items-center max-w-md',
    input: '$reset w-full mb-1 h-2 p-0 rounded-full',
    prefixIcon:
      '$reset w-4 mr-1 flex self-stretch grow-0 shrink-0 [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
    suffixIcon:
      '$reset w-4 ml-1 flex self-stretch grow-0 shrink-0 [&>svg]:max-w-[1em] [&>svg]:max-h-[1em] [&>svg]:m-auto',
  },
  select: {
    inner:
      'flex relative max-w-md items-center rounded mb-1 ring-1 ring-gray-old-n-40 ring-inset focus-within:ring-old-black focus-within:ring-2 [&>span:first-child]:focus-within:text-old-blue-500',
    input:
      'w-full h-48 px-16 py-8 border-none text-lg text-old-gray-700 placeholder-old-gray-400 formkit-multiple:p-0 data-[placeholder="true"]:text-old-gray-400 formkit-multiple:data-[placeholder="true"]:text-old-inherit',
    selectIcon:
      'flex h-48 w-20 shrink-0 mr-16 -ml-[1.5em] pointer-events-none [&>svg]:w-[1em]',
    option: 'formkit-multiple:p-3 formkit-multiple:text-sm text-old-gray-700',
  },
  submit: {
    input:
      `min-w-100 relative before:w-0 before:mr-0 before:border-0 before:transition-[width] before:transition-[border] before:duration-[0ms]
      formkit-loading:before:absolute formkit-loading:before:left-1/2 formkit-loading:before:-ml-9 formkit-loading:before:top-1/2 formkit-loading:before:-mt-9
      formkit-loading:before:text-base formkit-loading:before:leading-[18.px]
      formkit-loading:before:w-18 formkit-loading:before:h-18 formkit-loading:before:border formkit-loading:before:border-2
      formkit-loading:before:border-r-old-transparent formkit-loading:before:rounded-[18px] formkit-loading:before:border-old-white formkit-loading:before:animate-spin formkit-loading:text-transparent`,
  },
  textarea: {
    inner:
      'flex max-w-md rounded mb-1 ring-1 ring-old-n-gray-40 ring-inset focus-within:ring-old-black [&>label:first-child]:focus-within:text-old-blue-500',
    input:
      'block w-full h-32 px-12 py-12 border-none text-lg text-old-gray-700 placeholder-old-gray-400 resize-none focus:shadow-outline',
  },
  text: {
    inner: 'h-48',
    input: 'h-48',
    suffixIcon:
      '$reset flex self-stretch grow-0 shrink-0 cursor-pointer w-auto pr-16 pl-12 [&>svg]:max-w-[1.6em] [&>svg]:max-h-[1.6em] [&>svg]:m-auto',
  },
  password: {
    suffixIcon:
      '$reset flex self-stretch grow-0 shrink-0 cursor-pointer w-auto pr-16 pl-12 [&>svg]:max-w-[1.6em] [&>svg]:max-h-[1.6em] [&>svg]:m-auto',
  },
  checkbox: {
    outer: 'formkit-disabled:pointer-events-none',
    option: 'mb-12 last:mb-0 data-[disabled]:pointer-events-none',
    wrapper: '[&>span]:text-lg cursor-pointer',
    decorator: `inline-flex items-center justify-center w-20 h-20 my-2 ml-2 !mr-14 text-[7px] leading-5
      bg-none ring-inset ring-1 ring-old-n-gray-70 rounded-4 outline-none
      icon-save transition-all duration-300
      peer-hover:ring-old-n-gray-80
      peer-focus:ring-old-n-gray-80
      peer-checked:bg-old-n-black-100 peer-checked:text-old-white peer-checked:ring-old-n-black-100
      peer-checked:peer-hover:bg-old-n-black-90 peer-checked:peer-hover:ring-old-n-black-90
      peer-checked:peer-focus:bg-old-n-black-90 peer-checked:peer-focus:ring-old-n-black-90`,
    decoratorIcon: 'hidden',
  },
  DateInput: {
    inner: `ring-1 ring-old-n-gray-40 focus-within:ring-old-black focus-within:ring-2 rounded mb-2
      formkit-disabled:focus-within:ring-old-black formkit-disabled:focus-within:ring-1`,
  },
};
